<template>
  <div class="contenedor-principal">
    <!-- ================= DETALLE CON CARIÑO ================= -->
    <section ref="raiz" class="lluvia-sobres">
      
      <!-- 🦋 CAPA DE MARIPOSAS ANIMADAS (LIGERAS Y FLUIDAS EN MÓVIL) -->
      <div class="mariposas-layer" aria-hidden="true">
        <img 
          ref="mariposa1Ref" 
          src="@/assets/mariposa.png" 
          alt="Mariposa" 
          class="mariposa-img mariposa-1"
        />
        <img 
          ref="mariposa2Ref" 
          src="@/assets/mariposa.png" 
          alt="Mariposa" 
          class="mariposa-img mariposa-2"
        />
      </div>

      <div class="contenido">
        
        <!-- 🎭 MÁSCARA SUPERIOR -->
        <div class="mascara-wrapper">
          <img 
            ref="mascaraRef" 
            src="@/assets/mascarr.png" 
            alt="Máscara Antifaz" 
            class="mascara-img" 
          />
        </div>

        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Lluvia de</span><br />
          <span class="script">Sobres</span>
        </h2>

        <p ref="textoRef" class="texto">
          Tenerte a mi lado en este día tan especial es el regalo más significativo.✨<br /><br />
          Cualquier detalle adicional será recibido con amor y gratitud, sin ninguna obligación.
        </p>

        <!-- 🔹 SOBRE -->
        <img ref="sobreRef" :src="sobrePng" class="icono-sobre" alt="Sobre" />

        <!-- 🔹 TEXTO LLUVIA -->
        <p ref="lluviaTextoRef" class="lluvia-texto"></p>

        <!-- 🔹 GRACIAS -->
        <p ref="graciasRef" class="gracias"></p>
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq" aria-hidden="true"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der" aria-hidden="true"></div>

      <!-- 🔹 ONDAS INFERIORES -->
      <div class="ondas-decorativas onda-abajo" aria-hidden="true">
        <svg viewBox="0 0 1200 90" preserveAspectRatio="none">
          <!-- Línea 1 (Relleno que conecta con la tarjeta) -->
          <path d="M0,22 Q30,12 60,22 T120,22 T180,22 T240,22 T300,22 T360,22 T420,22 T480,22 T540,22 T600,22 T660,22 T720,22 T780,22 T840,22 T900,22 T960,22 T1020,22 T1080,22 T1140,22 T1200,22 L1200,0 L0,0 Z" fill="#800020"/>
          <!-- Línea 2 (Media) -->
          <path d="M0,50 Q30,40 60,50 T120,50 T180,50 T240,50 T300,50 T360,50 T420,50 T480,50 T540,50 T600,50 T660,50 T720,50 T780,50 T840,50 T900,50 T960,50 T1020,50 T1080,50 T1140,50 T1200,50" fill="none" stroke="#800020" stroke-width="7" stroke-linecap="round"/>
          <!-- Línea 3 (Sueltas abajo) -->
          <path d="M0,75 Q30,65 60,75 T120,75 T180,75 T240,75 T300,75 T360,75 T420,75 T480,75 T540,75 T600,75 T660,75 T720,75 T780,75 T840,75 T900,75 T960,75 T1020,75 T1080,75 T1140,75 T1200,75" fill="none" stroke="#800020" stroke-width="6" stroke-linecap="round"/>
        </svg>
      </div>

    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss2.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    // ================= PRIMER BLOQUE =================
    const raiz = ref(null)
    const mascaraRef = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const lluviaTextoRef = ref(null)
    const graciasRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)
    const mariposa1Ref = ref(null)
    const mariposa2Ref = ref(null)

    // ================= SEGUNDO BLOQUE =================
    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const graciasNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    // timeouts y triggers
    let toDer = null
    let toIzq = null
    let toDerNinos = null
    let toIzqNinos = null
    let stInstance = null
    let stInstanceNinos = null

    // ================= LLUVIA =================
    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 10) => {
      if (!contenedorEl) return

      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.alt = ''
        el.className = 'sobre-lluvia'

        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.5)
        const rndDur = gsap.utils.random(1.8, 2.6)
        const rndScale = gsap.utils.random(0.35, 0.7)
        const rndRot = gsap.utils.random(-25, 25)

        const xStart = lado === 'der' ? 110 : -10
        const xEnd = lado === 'der' ? -20 : 120

        const yStart = gsap.utils.random(-20, 20)
        const yEnd = gsap.utils.random(120, 140)

        gsap.fromTo(
          el,
          { xPercent: xStart, yPercent: yStart, rotate: rndRot, scale: rndScale, opacity: 0 },
          {
            xPercent: xEnd,
            yPercent: yEnd,
            rotate: rndRot + gsap.utils.random(-60, 60),
            opacity: 0.9,
            duration: rndDur,
            ease: 'power2.out',
            delay: rndDelay,
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      // ================= PRIMER BLOQUE =================
      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          const serifEl = tituloRef.value?.querySelector('.serif')
          const scriptEl = tituloRef.value?.querySelector('.script')

          // 1. Entrada de la máscara arriba
          if (mascaraRef.value) {
            tl.fromTo(
              mascaraRef.value,
              { opacity: 0, y: -25, scale: 0.8 },
              { opacity: 1, y: 0, scale: 1, duration: 0.6, ease: 'back.out(1.4)' }
            )
          }

          // 2. Entrada de Título (serif & script)
          if (serifEl) {
            tl.fromTo(
              serifEl,
              { opacity: 0, y: -24 },
              { opacity: 1, y: 0, duration: 0.5 },
              '-=0.3'
            )
          }

          if (scriptEl) {
            tl.fromTo(
              scriptEl,
              { opacity: 0, y: 18 },
              { opacity: 1, y: 0, duration: 0.45 },
              '-=0.2'
            )
          }

          // 3. Entrada de Texto explicativo
          if (textoRef.value) {
            tl.fromTo(
              textoRef.value,
              { opacity: 0, y: 14 },
              { opacity: 1, y: 0, duration: 0.4 },
              '-=0.1'
            )
          }

          // 4. Entrada del Sobre
          if (sobreRef.value) {
            tl.fromTo(
              sobreRef.value,
              { opacity: 0, y: -80, scale: 0.8 },
              { opacity: 1, y: 0, scale: 1, duration: 0.6, ease: 'back.out(1.7)' },
              '-=0.1'
            )
          }

          if (lluviaTextoRef.value) {
            tl.fromTo(
              lluviaTextoRef.value,
              { opacity: 0, y: 20 },
              { opacity: 1, y: 0, duration: 0.4 },
              '-=0.2'
            )
          }

          if (graciasRef.value) {
            tl.fromTo(
              graciasRef.value,
              { opacity: 0, y: 10 },
              { opacity: 1, y: 0, duration: 0.35 }
            )
          }

          toDer = setTimeout(() => crearLluvia(lluviaDer.value, 'der', 12), 80)
          toIzq = setTimeout(() => crearLluvia(lluviaIzq.value, 'izq', 12), 220)
        }
      })

      // Flotación sutil de mariposas
      if (mariposa1Ref.value) {
        gsap.to(mariposa1Ref.value, {
          y: '+=12',
          x: '+=6',
          duration: 3,
          repeat: -1,
          yoyo: true,
          ease: 'sine.easeInOut'
        })
      }

      if (mariposa2Ref.value) {
        gsap.to(mariposa2Ref.value, {
          y: '+=14',
          x: '-=6',
          duration: 3.4,
          repeat: -1,
          yoyo: true,
          ease: 'sine.easeInOut'
        })
      }

      // ================= SEGUNDO BLOQUE =================
      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const tl2 = gsap.timeline({ defaults: { ease: 'power3.out' } })

          const serifEl2 = tituloNinosRef.value?.querySelector('.serif')

          if (serifEl2) {
            tl2.fromTo(
              serifEl2,
              { opacity: 0, y: -24 },
              { opacity: 1, y: 0, duration: 0.5 }
            )
          }

          if (textoNinosRef.value) {
            tl2.fromTo(
              textoNinosRef.value,
              { opacity: 0, y: 14 },
              { opacity: 1, y: 0, duration: 0.4 },
              '-=0.05'
            )
          }

          toDerNinos = setTimeout(() => crearLluvia(lluviaNinosDer.value, 'der', 12), 80)
          toIzqNinos = setTimeout(() => crearLluvia(lluviaNinosIzq.value, 'izq', 12), 220)
        }
      })
    })

    onUnmounted(() => {
      if (toDer) clearTimeout(toDer)
      if (toIzq) clearTimeout(toIzq)
      if (toDerNinos) clearTimeout(toDerNinos)
      if (toIzqNinos) clearTimeout(toIzqNinos)

      if (stInstance) stInstance.kill()
      if (stInstanceNinos) stInstanceNinos.kill()

      ScrollTrigger.refresh()
    })

    return {
      raiz,
      mascaraRef,
      tituloRef,
      textoRef,
      sobreRef,
      lluviaTextoRef,
      graciasRef,
      mariposa1Ref,
      mariposa2Ref,
    
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
      graciasNinosRef,
    
      sobrePng
    }
  }
}
</script>

<style scoped>
.contenedor-principal {
  padding: 60px 0;
  margin-top:-110px;
}

.lluvia-sobres {
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 20px 20px;
  text-align: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: visible;
}

/* ================= MÁSCARA SUPERIOR ================= */
.mascara-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.mascara-img {
  width: 150px;
  height: auto;
  display: block;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
}

/* ================= MARIPOSAS ANIMADAS ================= */
.mariposas-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 4;
}

.mariposa-img {
  position: absolute;
  height: auto;
  opacity: 0.92;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.18));
  animation: aleteoMagico 1.6s infinite ease-in-out alternate;
  will-change: transform;
}

.mariposa-1 {
  top: 8%;
  left: 6%;
  width: 68px;
  transform: rotate(-15deg);
}

.mariposa-2 {
  top: 29%;
  right: 6%;
  width: 68px;
  transform: rotate(18deg);
}

@keyframes aleteoMagico {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0.58);
  }
}

/* ONDAS SVG DECORATIVAS */
.ondas-decorativas {
  position: absolute;
  left: 0;
  width: 100%;
  height: 80px;
  pointer-events: none;
  z-index: 3;
}

.ondas-decorativas svg {
  width: 100%;
  height: 100%;
  display: block;
}

.onda-arriba {
  top: -79px;
}

.onda-abajo {
  bottom: -79px;
}

.contenido {
  position: relative;
  z-index: 2;
  overflow: visible;
}

.titulo {
  margin: 0 0 10px;
  color: #9C1B2C;
  line-height: 1.05;
}

.titulo .serif {
  font-family: 'ludovica', cursive;
  font-size: 36px !important;
  color: #4f0f18;
  line-height: 1.5;
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.3));
}

.titulo .script {
  font-family: 'ludovica', cursive;
  font-size: 36px !important;
  line-height: 1.5;
  margin-top: -30px;
  color: #4f0f18;
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.3));
}

/* ================= TEXTO EXPLICATIVO FORMATO LIMPIO ================= */
.texto {
  /* Tipografía */
  font-family: 'Playfair Display', serif;
  font-size: 1rem !important;
  font-weight: 500;
  line-height: 1.5;

  /* Colores */
  color: rgba(58, 11, 11, 0.98);

  /* Espaciado */
  margin-top: 12px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  padding: 0 12px;
}

.icono-sobre {
  width: 180px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.12));
}

.gracias {
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.lluvia {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.lluvia-izq {
  left: 0;
}

.lluvia-der {
  right: 0;
}

.sobre-lluvia {
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.lluvia-texto {
  font-family: 'padres', serif;
  font-size: 18px;
  color: #ffffff;
  margin-top: 8px;
  letter-spacing: 0.05em;
  opacity: 0.95;
}

@media (max-width: 380px) {
  .titulo .serif {
    font-size: 50px;
  }
  .titulo .script {
    font-size: 40px;
  }
  .icono-sobre {
    width: 96px;
  }
  .mascara-img {
    width: 120px;
  }
}
</style>